import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './lib/reportWebVitals';
import { OFFLINE_COPY } from './lib/offline';
/* eslint-disable no-restricted-globals */
// No service worker in the offline copy: a file opened from disk has nothing to update from.
if (process.env.NODE_ENV === "production" && !OFFLINE_COPY && 'serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js').then(reg => {
    console.log('SW registered');

    // if a new SW is already waiting, activate it immediately
    if (reg.waiting) {
      reg.waiting.postMessage({ type: "SKIP_WAITING" });
    }

    // if a new SW is installing, listen for state changes
    if (reg.installing) {
      reg.installing.addEventListener("statechange", () => {
        if (reg.waiting) {
          reg.waiting.postMessage({ type: "SKIP_WAITING" });
        }
      });
    }

    // listen for future updates
    reg.addEventListener("updatefound", () => {
      const newWorker = reg.installing;
      if (newWorker) {
        newWorker.addEventListener("statechange", () => {
          if (reg.waiting) {
            reg.waiting.postMessage({ type: "SKIP_WAITING" });
          }
        });
      }
    });
  }).catch(console.error);

  // A new SW took over: the "New version ready" banner (components/UpdateBanner.js) offers the
  // reload. Not on a first visit - an uncontrolled page being claimed isn't an update.
  const hadController = Boolean(navigator.serviceWorker.controller);
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hadController) return;
    window.__ospreyUpdateReady = true;
    window.dispatchEvent(new Event("osprey-update-ready"));
  });
}

//This disables service workers when working on dev, comment it out if pushing to prod
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.getRegistrations().then((registrations) => {
//     console.log("rejnroejnr")
//     registrations.forEach((reg) => reg.unregister());
//   });
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
